import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import FieldPropType from './field';
import FilePropType from './file';

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes;

export const properties = {
  appStep: shape({
    appID: string.isRequired,
    params: objectOf(string)
  }),
  deadline: string,
  assignedTo: string,
  conditionCode: string,
  conditions: arrayOf(string),
  createdBy: string,
  description: string,
  displayName: string,
  descriptionPieces: oneOfType([
    string,
    shape({
      sourceText: string,
      fieldMap: objectOf(FieldPropType)
    })
  ]),
  endDate: string,
  fields: arrayOf(FieldPropType),
  files: arrayOf(FilePropType),
  fieldCount: number,
  isOverdue: bool,
  isTerminal: bool,
  maximumDuration: string,
  nextVersion: string,
  priority: string,
  processID: string,
  runID: string,
  taskID: string,
  taskName: string,
  processDisplayName: string,
  runDisplayName: string,
  requiredPreviousTasks: arrayOf(string),
  previousTasks: arrayOf(string),
  previousVersion: string,
  rejectedReason: string,
  roleID: string,
  role: shape({
    users: arrayOf(string),
    fields: arrayOf(string)
  }),
  startDate: string,
  status: string,
  taskNumber: number,
  teamName: string,
  webhookID: string
};

export default shape(properties);



// WEBPACK FOOTER //
// ./js/types/api/task.js